import { Body, Box, Image } from '@hover/blueprint';
import React from 'react';

import { useRenderingContext } from 'src/modules/renderings/hooks';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

const OrgBranding = () => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const { orgLogoUrl, orgName, isCaptureRequest } = useRenderingContext();

  if (!isCaptureRequest || !orgName) {
    return null;
  }
  return (
    <Box alignItems="center">
      <Body
        color="neutral.disabled"
        fontWeight={400}
        lineHeight={200}
        paddingRight={500}
      >
        {orgName}
      </Body>
      {orgLogoUrl && (
        <Image
          alt={`${orgName} ${t('renderings.logo')}`}
          borderLeft="1px solid #d5d5d5"
          maxHeight={400}
          paddingLeft={500}
          src={orgLogoUrl}
        />
      )}
    </Box>
  );
};

export { OrgBranding };
